import { ButtonTertiary } from 'components/Button/Button'
import { CopyButtonProps, StyledCheckIcon, StyledCopyIcon } from './CopyButton'
import { useCopyButton } from './useCopyButton'
import TypographyPrimary from 'components/Typography/Primary'

const LabeledCopyButton = ({ onCopyClick, value = '', dark = false, label }: CopyButtonProps) => {
    const { handleCopyClick, copied } = useCopyButton({ onCopyClick, value })

    return (
        <ButtonTertiary onClick={handleCopyClick}>
            <>
                {copied ? (
                    <StyledCheckIcon size={22} dark={dark} />
                ) : (
                    <StyledCopyIcon size={22} dark={dark} />
                )}
            </>

            <TypographyPrimary value={label ? label : 'Copy'} size={'small'} />
        </ButtonTertiary>
    )
}

export default LabeledCopyButton
